






























import {
  Vue,
  Component,
} from "@/shared/vuepack";

import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import { EbtoTransferOutComplete } from "@/employee/route-names";
import TransferStepsWidget from "./TransferStepsWidget.vue";
import DocumentSignatureDynamicTemplate from "@/shared/components/DocumentSignatureDynamicTemplate.vue";
import {
  CampaignDecision
} from "@/shared/types";
import moment from "moment";
import { useEbtoStore } from "@/shared/store/ebto";

@Component({
  components: {
    HsabLoginWrapper,
    DocumentSignatureDynamicTemplate,
    TransferStepsWidget
  }
})
export default class ESignature extends Vue {
  ebtoStore = useEbtoStore();

  isSigned = false;
  signatureData: string = null;
  isLoading = false;
  eSignName = "";
  hasScrolledToBottom = false;

  get dynamicHtml () {
    return `<p><b>ELECTRONIC SIGNATURES IN GLOBAL AND NATIONAL COMMERCE ACT: CONSENT TO USE ELECTRONIC RECORDS AND SIGNATURES</b></p>
      <p>In order to register for and use HSA Bank Online Services, you understand and agree that you must carefully read and accept this E-SIGN Consent to Use Electronic Records and Signatures (E-SIGN Consent Agreement) and keep a copy for your records.</p>
      <p>The Electronic Signatures in Global and National Commerce Act (ESIGN) is a United States federal law that allows for electronic signatures, documents and records to be as legally valid as their paper equivalents. You may choose to receive documents electronically instead of in paper form by affirmatively consenting to this Electronic Signature Consent Agreement (ESIGN). By providing your consent you agree to accept electronic delivery of all communications relating to your HSA Eligible Account, including, but not limited to, account statements or summaries, tax forms, claims related documents, notices and disclosures (“Communication”) and your electronic consent reasonably demonstrates that you can access information in the electronic form that will be used to provide the information that is the subject of the consent. We encourage you to retain all Communications. Your consent to electronic delivery will remain in effect until you notify us that you withdraw your consent.</p>
      <p>You agree to provide, and maintain, a valid email address within your online access profile. If you fail to provide or maintain a valid email address, we reserve the right to cease reliance on electronic delivery of any or all Communications.</p>
      <p><b>CONSENT:</b> You will be asked to confirm your acceptance of these terms before you are able to use these Services.  In doing so, you are confirming that (i) <strong>you have read and understand this E-SIGN Consent Agreement; </strong><strong>(ii)</strong> you agree to accept all Communications in an electronic form; (iii) you meet the system requirements; <a href="http://www.hsabank.com/hsabank/resources-and-services/browser-requirements">http://www.hsabank.com/hsabank/resources-and-services/browser-requirements</a> (iv) you have reasonably demonstrated your ability to receive, retain and view electronic documents on your Computer; and (v) you have an active and valid email address.</p>
      <p>We may choose to provide any available communications, whether account statements or summaries, tax forms, claims related documents, notices, or disclosures in paper format even though you have consented to their electronic delivery. In cases such as this we will not charge you for paper delivery. </p>
      <p><b>In order to withdraw your consent to accept documents electronically:</b></p>
      <p>You must first have consented to accept electronic delivery of communications such as account statements or summaries, tax forms, claims related documents, notices, or disclosures. Having agreed to ESIGN and the Online Services Agreement, you may navigate to the Preferences page and choose your communications preferences. Please note, some communications may incur a fee for paper distribution, as disclosed on your <i>HSA Bank Fee and Interest Rate Schedule</i>. To withdraw your full consent to this agreement please call 855-731-5213, available 24 hours a day, 7 days a week. The withdrawal of your full consent will be effective as soon as we process it. If you withdraw your full consent, we will remove your online access profile and you will no longer be able to access the online services. To regain access to the online services you will need to re-establish your online access profile which includes consenting to this agreement. </p>
      <p><strong data-renderer-mark="true">${this.ebtoStore.campaign.employerName}</strong> (the &ldquo;Employer&rdquo;) has currently designated HSA Bank as the custodian of the Health Savings Accounts to which it forwards contributions for its employees.</p>
      <p>Effective <strong data-renderer-mark="true">${moment.utc(this.ebtoStore.campaign.newCustodianEffectiveDate)
        .format("LL")}</strong>, <strong>${this.ebtoStore.campaign.newCustodian}</strong> (the &ldquo;Successor Custodian/Trustee&rdquo;) will be the custodial bank for your Employer affiliated health savings account. Employer will no longer make contributions to your HSA Bank health savings account.</p>
      <p>With this change in custodian, you may elect to keep your current health savings account with HSA Bank or direct HSA Bank to close your account and transfer the balance to Successor Custodian/Trustee.</p>
      <p>By clicking the box below, I am providing my electronic consent and direction that HSA Bank close my current HSA that is associated with Employer and transfer the balance to Successor Custodian/Trustee, as Successor Custodian/Trustee, effective <strong data-renderer-mark="true">${moment.utc(
          this.ebtoStore.campaign.newCustodianEffectiveDate).format("LL")}</strong>.</p>
      <p>Further, I acknowledge the following: </p>
      <ul>
      <li>In the event my HSA that is associated with Employer closes after <strong data-renderer-mark="true">${moment.utc(
            this.ebtoStore.campaign.dateTransfer).format("LL")}</strong>, I understand that I will be responsible for any and all applicable fees such as closing fee and related services.</li>
      <li>If I elect to transfer, I understand that I must have an open and active account at the Successor Custodian/Trustee.</li>
      <li>I may retain my account with HSA Bank, and I will be responsible for all fees and costs associated with the account.</li>
      <li>If I elect to transfer my account, a closing fee may be deducted by HSA Bank if my employer or other third party does not cover the closing fee. </li>
      <li>There must be no activity with your HSA Bank account for at least three (3) weeks prior to the closure of your account and transfer of the balance on or about <strong data-renderer-mark="true">${moment.utc(
              this.ebtoStore.campaign.dateTransfer).format("LL")}</strong>, otherwise there could be a delay or cancellation of your request. </li>
      <li>If I currently have invested a portion or all of my HSA balance, I may liquidate and transfer those funds back into the HSA prior to <strong data-renderer-mark="true">${moment.utc(
                this.ebtoStore.campaign.dateCutOff).format(
                  "LL")}</strong>.  If I do not transfer these funds back into the HSA prior to <strong data-renderer-mark="true">${moment.utc(
                    this.ebtoStore.campaign.dateCutOff).format("LL")}</strong>, HSA Bank is authorized to liquidate these funds on my behalf and close my investment account.  The proceeds from the liquidation will be transferred to my new HSA at Successor Custodian/Trustee. Certain fees to liquidate investments may apply, including but not limited to early redemption fees, and brokerage trading fees. These fees may be higher if HSA Bank executes these transactions rather than if you liquidate the investment assets yourself.</li>
      <li>This consent requests the transfer to occur on or about <strong data-renderer-mark="true">${moment.utc(
                      this.ebtoStore.campaign.dateTransfer).format("LL")}</strong>.  HSA Bank will make every effort to execute this transfer on that date, but certain circumstances may cause a delay.  Additionally, HSA Bank may not be able to execute this transfer request should I have a zero or negative balance on my account, my account is closed, or should Successor Custodian/Trustee not have an account in my name, or for other similar reasons.  HSA Bank is in no way responsible for the timing of my Successor Custodian/Trustee HSA being credited.</li>
      </ul>`;
  }

  onSubmit () {

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isLoading = true;
      this.ebtoStore.finalizeEbtoStayOffer({
        decision: CampaignDecision.TransferOut,
        userId: this.ebtoStore.verifiedUser.userId,
        eSignName: this.eSignName
      }).then(() => {
        this.isLoading = false;
        if (this.ebtoStore.isUserFlowComplete) {
          this.$router.push({ name: EbtoTransferOutComplete });
          return;
        }
      });
    });
  }

  handleScroll (el) {
    if ((el.target.offsetHeight + el.target.scrollTop) >= (el.target.scrollHeight - 1)) {
      this.hasScrolledToBottom = true;
    }
  }
}
